import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import '../CardTransactions/extendedTransactions.scss'

interface CardProps {
	title?: string
	icon?: any
	specialContent?: JSX.Element[]
	content?: string[]
	value?: string[]
	inlineIconStyle?: {
		transform: 'matrix(0.87, -0.5, 0.5, 0.87, 0, 0)'
	}
}

export const CardItem = ({
	title,
	content,
	icon,
	value,
	inlineIconStyle,
	specialContent,
}: CardProps) => {
	const [isCollapsed, setIsCollapsed] = useState(false)
	const { t } = useTranslation()

	const toggleCollapse = () => {
		setIsCollapsed(!isCollapsed)
	}

	return (
		<div className="card rounded cardContainer">
			{title && (
				<div
					className="row pt-3 pb-3 ml-2 mr-2 pl-2"
					onClick={toggleCollapse}>
					<div className="col-10 d-flex">
						<FontAwesomeIcon
							icon={icon}
							size="lg"
							style={inlineIconStyle}
						/>
						<span className="text-left pl-2">{title}</span>
					</div>
					<FontAwesomeIcon
						className="col-2 pr-0"
						icon={isCollapsed ? faChevronDown : faChevronUp}
					/>
				</div>
			)}
			{!isCollapsed && (
				
				<div className="card-body d-flex contentContainer" >
					{content ? (
					<>
					<div className="light d-flex flex-column text-left keyContainer">
						
						{content?.map((content, index) => (
							<div className="py-1" key={index}>
								{t(content)}
							</div>
						))}
						
					</div>

					<div className=" d-flex  flex-column text-right valueContainer ">
						{
							value?.map((key, index) => (
							<div className="py-1" key={index}>
								{key}
							</div>
						))
						}
						
					</div></>
					) : (
							<div className="p-1 specialContainer">
								{specialContent}
							</div>
					)}

				</div>
			)}
		</div>
	)
}
